import { createSlice } from '@reduxjs/toolkit'
import {getFactoryChannels} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= { 
  channels: [], 
  loading: "idle",
  error: null }

const factoryChannelsSlice = createSlice({
  name: 'factoryChannels',
  initialState,
  reducers: {
    clearProvinceError: (state)=>{
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getFactoryChannels.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getFactoryChannels.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.channels = action.payload
      
    },
    [getFactoryChannels.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export default factoryChannelsSlice.reducer
